export enum PatientActionTypes {
    API_RESPONSE_SUCCESS = '@@patient/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@patient/API_RESPONSE_ERROR',

    ADD_PATIENT = '@@patient/ADD_PATIENT',
    EDIT_PATIENT = '@@patient/EDIT_PATIENT',
    GET_PATIENT = '@@patient/GET_PATIENT',
    GET_PATIENTS = '@@patient/GET_PATIENTS',
    GET_VALIDATE_PATIENT = '@@patient/GET_VALIDATE_PATIENT',
    RESET = '@@patient/RESET',
    RESET_SUCCESS = '@@patient/RESET_SUCCESS',
    RESET_ERROR = '@@patient/RESET_ERROR',
}
